import registerForRails from 'js/utils/registerForRails';
import LazyInterruptionChooser from 'js/liswp/LazyInterruptionChooser';
import Search from 'js/search/react/Search';
import SearchOnboardingOverhaul from 'js/search/react/SearchOnboardingOverhaul';

registerForRails({
  Search,
  SearchOnboardingOverhaul,
  InterruptionChooser: LazyInterruptionChooser,
});
